import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import {Observable} from 'rxjs/Observable';


import {
  ExceptionService
  // CONFIG, MessageService, SpinnerService
} from '../core';
import { API } from '../shared/constants';
//TODO: Change to login url
//let loginUrl = API.ENDPOINT.LOGIN;

@Injectable()
export class LoginService {

  private loginObserver: any;
  public event: any;

  constructor(
    private http: Http,
    // private exceptionService: ExceptionService,
    private router: Router
  ) {
    this.loginObserver = null;
    this.event = Observable.create(observer => {
    this.loginObserver = observer;
  });}

  login(user: any): any {
      return this.http
        .post(API.ENDPOINT.AUTHENTICATE, user)
        .toPromise()
        .then(res => {
          var user = res.json().userDetails[0];
          user.landPage ='/dashboard';
          /*switch (user.role) {
            case "marketing":
              user.landPage='/products';
              break;
            case "rh":
              user.landPage='/menu';
              break;
            case "faq-rh":
              user.landPage='/faq';
              break;
            case "mindset":
              user.landPage='/file';
              break;
            default:
              user.landPage ='/news';
              break;
          }*/
          sessionStorage.setItem("user", JSON.stringify(user));
          this.loginObserver.next(true);
          return user;
        })
        .catch((res) => {
          return res;
        });
  }

  logout(){
    sessionStorage.clear();
    this.router.navigate(['/login']);
    this.loginObserver.next(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/login.service.ts